import { createStyles, makeStyles } from '@material-ui/core/styles';

const styles = createStyles({
  root: {
    boxSizing: 'border-box',
    height: '40px',
    paddingTop: '5px',
    paddingLeft: '5px',
    paddingBottom: '0',
    paddingRight: '32px',
    backgroundColor: '#fff',
    '& .status': {
      display: 'none'
    }
  },
  icon: {
    fontSize: '20px',
    width: '16px',
    height: '16px',
    top: 'calc(50% - 8px)'
  }
});

export const emptyStyles = createStyles({
  root: {
    paddingLeft: '36px',
    pointerEvents: 'none'
  }
});

export const subheaderStyles = createStyles({
  root: {
    color: '#989898',
    pointerEvents: 'none'
  }
});

export const useCustomOptionStyle = makeStyles({
  container: {
    backgroundColor: '#fff',
    maxWidth: '100%',
    overflow: 'hidden',
    marginLeft: '16px',
    '&:hover': {
      backgroundColor: '#d1f0e5',
      '& > $var': {
        backgroundColor: '#3dba90',
        color: '#fff'
      },
      '& > $sbj': {
        color: '#2f9271'
      }
    },
    '&.Mui-selected': {
      backgroundColor: '#fff',
      '& > $var': {
        backgroundColor: '#3dba90',
        color: '#fff'
      },
      '& > $sbj': {
        color: '#3dba90'
      }
    }
  },
  root: {
    padding: '0 5px',
    height: '30px',
    lineHeight: '30px',
    color: '#6b6b6b'
  },
  var: {
    display: 'inline-block',
    paddingLeft: '8px',
    paddingRight: '8px',
    maxWidth: 'calc(100% - 16px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#6b6b6b',
    backgroundColor: '#eee',
    borderRadius: '4px',
    transition: '0.2s',
    transitionProperty: 'color, background-color',
    '&::before': {
      content: '"# "'
    }
  },
  sbj: {
    color: '#6b6b6b',
    transition: 'color 0.2s'
  }
});

export default styles;
